app.service('dynamicSuite', function (productCardConfig, pageConfig, modal, lazyLoad, price, cartManager, viewPoint, log) {
	// obsługuje zestawy na KP w eK
	let config, $ajax, isInit = false;
	let selectedPackages = [];
	let $tab, $dynamicSuiteFilter, $packages, $normalPrice, $suitePrice;
	let selectProductModal;
	let initiallySelectedProducts = [];

	function openModal(packageIndex) {
		selectProductModal = modal.open(`package-products-${packageIndex}`);

		const selectedProduct = $packages.eq(packageIndex)
			.find('.package-product-item.is-selected')
			.index();

		selectProductModal.$modal
			.find('.package-products-modal > div')
			.eq(selectedProduct)
			.find('.js-select-package-product')
			.prop('checked', true);

		selectProductModal.$modal
			.find('.package-product-item')
			.each((i, el) => el.className = 'package-product-item')
	}

	function setEvents() {
		if (isInit === false) {
			isInit = true;
			const groupName = productCardConfig.getData().groupName.split(" ").join("_");
			$tab
				.on('click', '.js-add-dynamic-suite', function () {
					let productId = $(this).data('product-id');
					let packageProductsIds = $packages.filter('.is-selected')
						.find('.package-product-item.is-selected')
						.map((i, el) => $(el).data('package-product-id'))
						.toArray();
					cartManager.addDynamicSuite(productId, packageProductsIds);
					UA.interaction('KP_Zestawy_eK', 'Dodanie_do_koszyka_liczba', `${groupName}_zestaw_${packageProductsIds.length}_akcesoria`);

					if (hasAnyProductInSuiteBeenChanged(packageProductsIds)) {
						UA.interaction('KP_Zestawy_eK', 'Dodanie_do_koszyka', `${groupName}_Zmieniony`);
					} else {
						UA.interaction('KP_Zestawy_eK', 'Dodanie_do_koszyka', `${groupName}_Domyslny`);
					}
				})
				.on('click', '.js-select-product', function () {
					const packageIndex = $(this).data('package-index');
					openModal(packageIndex);
					UA.interaction('KP_Zestawy_eK', 'Wybierz_inny_produkt', groupName);
				})
				.on('click', '.js-select-package', function () {
					const $this = $(this);
					const selected = $this.hasClass('selected');
					const index = $this.closest('.dynamic-suite-package').index();

					if (selected) {
						selectedPackages = selectedPackages.filter(i => i !== index);
						$this.removeClass('selected');
					} else {
						selectedPackages = selectedPackages.concat(index);
						$this.addClass('selected');
					}
					disableUnselectingLastPackage();
					updateDiscounts();
					calculateTotal();
				})
				.on('click', '.product-photo', function() {
					UA.interaction('KP_Zestawy_eK', 'Klikniecia', `${groupName}_Zdjecie`);
				})
				.on('click', '.package-product-photo a', function(e) {
					e.preventDefault();
					UA.interaction('KP_Zestawy_eK', 'Klikniecia', `${groupName}_Zdjecie`);
					window.location.href = this.href;
				});

			$('body').on('click', '.js-select-package-product', function () {
				selectProductModal.$modal.find('.js-select-package-product')
					.not($(this))
					.prop('checked', false);

				const packageIndex = +this.value;
				const productIndex = $(this).closest('div').index();

				$packages
					.eq(packageIndex)
					.find('.package-product-item')
					.removeClass('is-selected')
					.eq(productIndex)
					.addClass('is-selected');

				updateDiscounts();
				calculateTotal();

				selectProductModal.close();

				lazyLoad.update();
			});
		}
	}

	function hasAnyProductInSuiteBeenChanged(packageProductsIds) {

		let hasAnyProductChanged = false;

		packageProductsIds.forEach(id => {
			if (initiallySelectedProducts.indexOf(id) === -1) {
				hasAnyProductChanged = true;
			}
		});

		return hasAnyProductChanged;
	}

	function setElements() {
		$packages = $tab.find('.dynamic-suite-package');
		$normalPrice = $tab.find('.dynamic-suite-common-price .price-normal');
		$suitePrice = $tab.find('.dynamic-suite-discounted-price .price-normal');
	}

	function reset() {
		if (selectedPackages.length) {
			selectedPackages.forEach(index => {
				if (modal.isExist(`package-products-${index}`)) {
					modal.destroy(`package-products-${index}`);
				}
			});
			selectedPackages = [];
		}
	}
	function disableUnselectingLastPackage() { // blokowanie możliwości odznaczneia ostatniego akcesorium zestawu
		const $selectedPackages = $packages.find('.js-select-package.selected');
		if ($selectedPackages.length === 1 ) {
			$selectedPackages.addClass('disabled');
		}else if ($selectedPackages.length > 1 ) {
			$packages.find('.js-select-package').removeClass('disabled');
		}
	}

	function load() {
		const filter = $dynamicSuiteFilter.val();
		const wcShopCode = pageConfig.getData('wc').shopCode;
		const data = {
			'productId': config.id,
			'filter': filter,
		}
		if (wcShopCode) {
			data.shopCode = wcShopCode;
		}
		$tab.addClass('loading');
		if($ajax){
			$ajax.abort();
		}
		$ajax=$.ajax({
			url:'/product-card-dynamic-suite.ltr',
			data: data,
			success:function(html){
				loadSuccess(html);
			},
			error:function(){
				console.log('Błąd ładowania zestawów dynamicznych');
			},
			complete:function(){
				$tab.removeClass('loading');
			}
		});
	}
	function loadSuccess(html) {
		reset();
		$('#dynamic-suite-content', $tab).html(html);
		setElements();
		setEvents();
		selectFirstProduct();
		selectAllPackages();
	}

	function init() {
		$tab = $('#dynamic-suite');
		$dynamicSuiteFilter=$('#wc-dynamic-suite-filter', $tab);

		if (!$tab.length && !$dynamicSuiteFilter.length) return;
		config = $.extend({}, productCardConfig.getData());

		load();

		$dynamicSuiteFilter.change(function(){
			load();
		});

	}

	function selectFirstProduct() {
		let $items = $packages.find('.package-product-item:first-child').addClass('is-selected');
		$items.each(function() {
			let productId = $(this).data('package-product-id');
			initiallySelectedProducts.push(productId);
		});
	}

	function selectAllPackages() {
		$packages.find('.js-select-package').click();
	}

	function updateDiscounts() {
		$packages.each((i, el) => el.className = 'dynamic-suite-package');

		if (!selectedPackages.length) return;

		selectedPackages.forEach(index => {
			$packages.eq(index).addClass('is-selected');
		});
	}

	function calculateTotal() {
		$tab.toggleClass('no-accessories', !selectedPackages.length);
		
		if (!selectedPackages.length) return;
		
		$tab.find('.dynamic-suite-products-quantity').text(selectedPackages.length + 1);
		const mainProductPrice = +$tab.find('.suite-main-product .product-price').data('price');

		const productPrices = $packages
			.filter('.is-selected')
			.find('.package-product-item.is-selected')
			.map(function () {
				const discountedPrice = +$(this).find('.package-product-suite-price').data('price');
				const normalPrice = +$(this).find('.package-product-common-price').data('price');

				return {
					discountedPrice,
					normalPrice
				};
			})
			.get();

		const suitePrice = price.add(mainProductPrice, productPrices.reduce((acc, next) => acc + next.discountedPrice, 0));
		const normalPrice = price.add(mainProductPrice, productPrices.reduce((acc, next) => acc + next.normalPrice, 0));

		renderTotal(suitePrice, normalPrice);
	}

	function renderTotal(suitePrice, normalPrice) {
		$normalPrice.text(price.format(normalPrice, true, true));
		$suitePrice.text(price.format(suitePrice, true, true));
	}

	return {
		init
	};
});
